<template>
  <RfAuth
    title="Set Password"
    :error="props.loginError"
    @submit="onSetPassword"
    @keyup.enter="onSetPassword"
  >
    <template #inputs>
      <RfInput
        v-bind="formPasswords.props.password.value"
        v-model="formPasswords.values.password.value"
        :errorMessage="formPasswords.errors.value?.password"
        variant="outlined"
        title="Password"
        placeholder="Enter your password"
        :type="showPassword ? 'text' : 'password'"
        class="w-full"
        size="large"
      >
        <template #prepend>
          <RfLockKeyholeIcon class="h-6! w-6! shrink-0" />
        </template>
        <template #append>
          <button
            type="button"
            class="relative inline-flex shrink-0 place-items-center before:absolute before:-inset-3 before:cursor-pointer"
            @click="showPassword = !showPassword"
          >
            <RfEyeOpenIcon v-if="showPassword" class="h-6! w-6!" />
            <RfEyeClosedIcon v-else class="h-6! w-6!" />
          </button>
        </template>
      </RfInput>
      <RfInput
        v-bind="formPasswords.props.confirmPassword.value"
        v-model="formPasswords.values.confirmPassword.value"
        :errorMessage="formPasswords.errors.value?.confirmPassword"
        variant="outlined"
        title="Confirm Password"
        :type="showConfirmPassword ? 'text' : 'password'"
        placeholder="Enter your password again"
        class="mt-6 w-full"
        size="large"
      >
        <template #prepend>
          <RfLockKeyholeIcon class="h-6! w-6! shrink-0" />
        </template>
        <template #append>
          <button
            type="button"
            class="relative inline-flex shrink-0 place-items-center before:absolute before:-inset-3 before:cursor-pointer"
            @click="showConfirmPassword = !showConfirmPassword"
          >
            <RfEyeOpenIcon v-if="showConfirmPassword" class="h-6! w-6!" />
            <RfEyeClosedIcon v-else class="h-6! w-6!" />
          </button>
        </template>
      </RfInput>
      <div class="mt-6 inline-flex">
        <RfCheckbox v-model="policyCheck">
          <div class="text-action-buttons text-grey-1">
            By checking this box you are agreeing to our
            <a
              target="_blank"
              class="underline"
              href="https://recurly.com/legal/terms/"
              @click.stop
            >
              terms of use
            </a>
            and
            <a
              target="_blank"
              class="underline"
              href="https://recurly.com/legal/privacy/"
              @click.stop
            >
              privacy policy
            </a>
          </div>
        </RfCheckbox>
      </div>
    </template>
    <template #footer>
      <RfButtonNew
        class="w-full"
        size="x-large"
        type="secondary"
        :disabled="!policyCheck || !formPasswords.meta.value.valid"
        @click="onSetPassword"
      >
        Submit
      </RfButtonNew>
    </template>
  </RfAuth>
</template>

<script setup>
import { ref } from "vue";
import RfAuth from "@/blocks/RfAuth.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfCheckbox from "@/components/inputs/RfCheckbox.vue";
import RfInput from "@/components/inputs/RfInput.vue";
import RfEyeOpenIcon from "@/components/icons/RfEyeOpenIcon.vue";
import RfEyeClosedIcon from "@/components/icons/RfEyeClosedIcon.vue";
import RfLockKeyholeIcon from "@/components/icons/RfLockKeyholeIcon.vue";
import { useFormPasswords } from "@/utils/composables/useFormsValidation";

const emit = defineEmits(["submit"]);
const props = defineProps({ loginError: { type: String, default: null } });
const formPasswords = useFormPasswords();

const policyCheck = ref(false);
const showPassword = ref(false);
const showConfirmPassword = ref(false);

const onSetPassword = () => {
  if (!policyCheck.value) return;
  if (!formPasswords.meta.value.valid) return;
  emit("submit", {
    password: formPasswords.values.password.value,
    password_confirmation: formPasswords.values.confirmPassword.value,
  });
};
</script>
